import * as yup from "yup";
import type { Asserts } from "yup";

// Response from /shipments/pay validation

const paymentDataSchema = yup.object({
  paymentUrl: yup.string().optional(),
  paymentParameters: yup.object().optional(),
  method: yup.string().oneOf(["GET", "POST"]).optional(),
});

const paymentSchema = yup.object({
  isPaid: yup.bool().required(),
  identifier: yup.string().required(),
  paymentData: paymentDataSchema.optional(),
  redirect: yup.bool().optional(),
  overDue: yup.bool().required(),
});

export type TPaymentResponse = Asserts<typeof paymentSchema>;

const validatePaymentResponse = (response: any): TPaymentResponse => paymentSchema.validateSync(response);

export default validatePaymentResponse;
